<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
    variant: {
      type: String,
      default: 'neutral',
      validator: value =>
        ['neutral', 'success', 'error', 'info', 'warning'].includes(value),
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  computed: {
    variantClass() {
      return (
        {
          neutral: 'bg-n-slate-12 dark:bg-n-slate-7 text-white',
          success: 'bg-lais-success text-white',
          error: 'bg-lais-danger text-white',
          info: 'bg-lais-info text-white',
          warning: 'bg-lais-warning text-white',
        }[this.variant] || 'bg-n-slate-12 dark:bg-n-slate-7 text-white'
      );
    },
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <div
      role="alert"
      aria-live="polite"
      aria-atomic="true"
      class="shadow-sm rounded-lg items-center gap-3 inline-flex mb-2 max-w-[25rem] min-h-[1.875rem] min-w-[15rem] px-6 py-3 text-left"
      :class="variantClass"
    >
      <div class="text-sm font-medium text-white dark:text-white">
        {{ message }}
      </div>
      <div v-if="action">
        <router-link
          v-if="action.type == 'link'"
          :to="action.to"
          class="font-medium cursor-pointer select-none text-n-blue-10 hover:text-n-brand"
        >
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>
